import { FC } from "react"
import styles from './index.module.css'
type Props = {
  sellerInfo:any
}




const InfoSeller:FC<Props> = ({sellerInfo})=>{

  if(!sellerInfo){
    return null;
  }

  return (
    <div className={styles.content}>
      	{sellerInfo && (
							<>
								<h4>
									Informações do Vendedor
								</h4>

								<div className={styles.content_info}>
									<p>
										<b>Nome: </b>
										{sellerInfo.name}
									</p>
								</div>

							</>


						)}
    </div>
  )
}

export {InfoSeller}